import api from './api';

// Per-company lead keywords (Settings → Keywords). These drive the scrapers'
// pre-filter; the backend classifier still decides lead quality.
export async function getLeadKeywords(): Promise<string[]> {
  const { data } = await api.get('/settings/keywords');
  return data.keywords || [];
}

export async function updateLeadKeywords(keywords: string[]): Promise<string[]> {
  const { data } = await api.put('/settings/keywords', { keywords });
  return data.keywords || [];
}
